// src/lib/date-utils.ts
import { Timestamp } from "firebase/firestore";

/**
 * Safely converts various date formats (Timestamp, object with _seconds, ISO string)
 * into a standardized ISO string format. Returns null if the input is invalid.
 * @param date - The date value to convert.
 * @returns An ISO string or null.
 */
export const safeISOString = (date: any): string | null => {
  if (!date) {
    return null;
  }

  // Handle Firestore Timestamp object
  if (date instanceof Timestamp) {
    return date.toDate().toISOString();
  }

  // Handle object format { _seconds: number, _nanoseconds: number }
  if (date && typeof date === 'object' && '_seconds' in date && '_nanoseconds' in date) {
    try {
      const newDate = new Date(date._seconds * 1000);
      if (isNaN(newDate.getTime())) return null;
      return newDate.toISOString();
    } catch (e) {
      return null;
    }
  }

  // Handle ISO string format
  if (typeof date === 'string') {
    try {
      const parsedDate = new Date(date);
      if (isNaN(parsedDate.getTime())) return null;
      return parsedDate.toISOString();
    } catch(e) {
      return null;
    }
  }

  // Handle native Date object
  if (date instanceof Date) {
     if (isNaN(date.getTime())) return null;
     return date.toISOString();
  }

  return null;
};
